// Redirector.js
import React, { useEffect } from 'react';

const Redirector = () => {
  const PLAY_URL = "https://play.google.com/store/apps/details?id=alemtilsimat.zoodrugtm.app";
  const IOS_URL = "https://apps.apple.com/us/app/zoo-drug-tm/id6755528881";

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      // iOS ise
      window.location.replace(IOS_URL);
    } else {
      window.location.replace(PLAY_URL);
    }
  }, []);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
      <h3>You are being redirected…</h3>
      <p>Please wait.</p>
    </div>
  );
};

export default Redirector;